import type { IAddContactNoteCallingActionPayload } from 'entities/AICalling/api/types.ts'
import { type IMessageActionData } from 'entities/TemplateActions/actions.tsx'
import { addContactNote } from 'widgets/TemplateActions/addContactNote'
import { type AgentInstructionsStore } from 'pages/chatbot/pages/calling/ui/AICallingAgentManage/ui/AgentInstructions/store/AgentInstructionsStore.tsx'
import { createAddContactNoteCallingAction } from './createAddContactNoteCallingAction.ts'

export const onAddContactNoteChipClick =
  (store: AgentInstructionsStore) => (chip: HTMLSpanElement, data: IMessageActionData) => {
    const { getAgentAction, onUpdateAgentAction, deleteChipAndAgentAction, entities } = store
    let action: IAddContactNoteCallingActionPayload | undefined

    if ('token_id' in data) {
      const token_id = data.token_id
      const findAction = getAgentAction(token_id)

      if (token_id) {
        if (findAction?.action_type === 'add_contact_note') {
          action = findAction
        }
      }
    }
    if (action) {
      return addContactNote(
        {
          onSave: (data) =>
            onUpdateAgentAction(createAddContactNoteCallingAction(data, action.settings.token_id)),
          onDelete: () => deleteChipAndAgentAction(chip, action),
          data: action.settings,
        },
        entities
      )
    }
  }
